module.exports = __webpack_public_path__ + "img/nursery4.ba52205c.jpg";